import React, { useEffect, useState } from 'react';
import { cn } from '../../utils/classUtils';
import LeoCollapseTab from '../../assets/img/leoCollapseTab.svg';
import LeoExpandTab from '../../assets/img/leoExpandTab.svg';
import { AnimatedDiv } from './AnimatedDiv';
import NeoLeoPanelContainer from './NeoLeoPanelContainer';
import './NeoLeoIndex.css';

interface NeoLeoSidebarProps {
  isNeoLeoOpen: boolean;
  closeLeo: () => void;
}

const NeoLeoSidebar: React.FC<NeoLeoSidebarProps> = ({
  isNeoLeoOpen,
  closeLeo,
}) => {
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const [showExpansionTab, setShowExpansionTab] = useState<boolean>(true);
  const [expansionAnimationEnded, setExpansionAnimationEnded] =
    useState<boolean>(false);
  const [leoPanelExpanded, setLeoPanelExpanded] = useState<boolean>(false);

  useEffect(() => {
    if (showExpansionTab) {
      setTimeout(() => setExpansionAnimationEnded(true), 200);
    } else {
      setExpansionAnimationEnded(false);
    }
  }, [showExpansionTab]);

  return (
    <div>
      <div className='h-full-window flex flex-row justify-between overflow-y-auto'>
        <AnimatedDiv visible={isNeoLeoOpen}>
          <div
            className={cn(
              'w-[365px] overflow-visible z-40 transition-all duration-300 ease-in-out',
            )}
            onMouseEnter={() => {
              if (!leoPanelExpanded) {
                setShowExpansionTab(true);
              }
            }}
            onMouseLeave={() => {
              if (!leoPanelExpanded) {
                setShowExpansionTab(false);
              }
            }}
            data-testid='mini-neo-leo-panel'
          >
            <div
              className={cn(
                'flex flex-row overflow-visible absolute top-0 bottom-0 right-0 z-[48] pt-[80px]',
                leoPanelExpanded ? `w-[750px]` : `w-[365px]`,
              )}
            >
              <AnimatedDiv visible={showExpansionTab}>
                <div
                  className={cn(
                    'absolute flex h-full top-1/2 -translate-y-1/2 -left-8 items-center w-12',
                    {
                      'z-[48]': expansionAnimationEnded,
                    },
                  )}
                >
                  <div
                    onClick={() => {
                      const expanded = leoPanelExpanded;
                      setLeoPanelExpanded(!expanded);
                      if (expanded) {
                        setShowExpansionTab(false);
                      }
                    }}
                    className={cn(
                      'cursor-pointer overflow-hidden -mr-2 w-full',
                      showExpansionTab
                        ? 'animate-leo-expand-button-enter'
                        : 'animate-leo-expand-button-exit',
                    )}
                  >
                    {leoPanelExpanded ? (
                      <img src={LeoCollapseTab} alt='leo-collapse-tab' />
                    ) : (
                      <img src={LeoExpandTab} alt='leo-expand-tab' />
                    )}
                  </div>
                </div>
              </AnimatedDiv>
              <div
                className={cn(
                  'relative h-full flex flex-row overflow-visible w-full border-l border-[#2D355C]',
                )}
              >
                <div
                  className={cn(
                    'flex flex-col justify-between bg-primary-navy h-full w-full overflow-hidden',
                  )}
                >
                  <NeoLeoPanelContainer
                    setShowHistory={setShowHistory}
                    showHistory={showHistory}
                    onClose={closeLeo}
                  />
                </div>
              </div>
            </div>
          </div>
        </AnimatedDiv>
      </div>
    </div>
  );
};

export default NeoLeoSidebar;
